/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Code_DescInputs */

const en_mk_tb_code_desc = /** @type {(inputs: Mk_Tb_Code_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync its manifest and review proposed changes alongside existing work.`)
};

const id_mk_tb_code_desc = /** @type {(inputs: Mk_Tb_Code_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinkronkan manifest dan tinjau usulan perubahan bersama pekerjaan yang sudah ada.`)
};

/**
* | output |
* | --- |
* | "Sync its manifest and review proposed changes alongside existing work." |
*
* @param {Mk_Tb_Code_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_code_desc = /** @type {((inputs?: Mk_Tb_Code_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Code_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_code_desc(inputs)
	return en_mk_tb_code_desc(inputs)
});